exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ModifyEligibilityConfirmation_Caution_3_GCp {\n    color: red;\n    fontSize:16px;\n    paddingBottom: 5px;\n}\n\n.ModifyEligibilityConfirmation_Section_255nz {\n    width: 50%;\n}\n\n.ModifyEligibilityConfirmation_SectionTitle_3KYTB {\n    padding-bottom: 5px;\n    font-weight: bolder;\n    color: #660000;\n}\n\n.ModifyEligibilityConfirmation_ButtonDiv_2_aHB {\n    display: flex;\n    justify-content: center;\n}\n\n.ModifyEligibilityConfirmation_EligSection_1rkK2 {\n    display: flex;\n    flexFlow: row;\n    width: 100%\n}", ""]);

// Exports
exports.locals = {
	"Caution": "ModifyEligibilityConfirmation_Caution_3_GCp",
	"Section": "ModifyEligibilityConfirmation_Section_255nz",
	"SectionTitle": "ModifyEligibilityConfirmation_SectionTitle_3KYTB",
	"ButtonDiv": "ModifyEligibilityConfirmation_ButtonDiv_2_aHB",
	"EligSection": "ModifyEligibilityConfirmation_EligSection_1rkK2"
};